import { Box } from '@ltvco/refresh-lib/theme';

import { useCallerIdSmokeTest } from './CallerIdSmokeTestContext';

/** Promo row + report nav; keep 68 in sync with CallerIdStickyBar `bottom`. */
const STICKY_STACK_RESERVE_PX = 88 + 68;

/**
 * Bottom scroll padding so report content is not hidden behind sticky CTAs.
 */
export function CallerIdStickySpacer(): JSX.Element | null {
  const { isStickyBarVisible } = useCallerIdSmokeTest();

  if (!isStickyBarVisible) {
    return null;
  }

  return (
    <Box
      aria-hidden
      sx={{
        height: STICKY_STACK_RESERVE_PX,
        width: '100%',
        flexShrink: 0,
      }}
    />
  );
}
